import './ExportTicketModalView.scss';
import angular from 'angular';
export class ExportTicketModalController {
    static $inject = ['close', 'isTranscriptionExporting', 'period', 'teams', 'operators', 'tags', 'customers', 'ids', '$translate', '$rootScope'];
    constructor(close, isTranscriptionExporting, period, teams, operators, tags, customers, ids, $translate, $rootScope) {
        'ngInject';
        this.close = close;
        this.isTranscriptionExporting = isTranscriptionExporting;
        this.period = period;
        this.teams = teams;
        this.operators = operators;
        this.tags = tags;
        this.customers = customers;
        this.ids = ids;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
    }
    async $onInit() {
        this.formatFilters();
        await this.translateTexts();
        angular.element(document).ready(() => {
            setTimeout(() => {
                this.verifyOverflow();
            }, 400);
        });
    }
    async translateTexts() {
        this.titleText = (this.formatedPeriod && !(this.formatedTeams || this.formatedOperators || this.formatedTags || this.formatedCustomers || this.formatedIds)) ?
            await this.$translate('modules.application.detail.attendance.history.exportTickets.exportModal.onlyPeriodTitle') :
            await this.$translate('modules.application.detail.attendance.history.exportTickets.exportModal.multiplesFiltersTitle');
        this.confirmButtonText = this.isTranscriptionExporting ?
            (this.ids.length > 1 ?
                await this.$translate('modules.application.detail.attendance.history.exportTickets.exportModal.exportTicketsButton') :
                await this.$translate('modules.application.detail.attendance.history.exportTickets.exportModal.exportTicketButton')) :
            await this.$translate('modules.application.detail.attendance.history.exportTickets.exportModal.exportListButton');
    }
    closeModal(isFilterConfirmmed) {
        this.close(isFilterConfirmmed);
    }
    formatFilters() {
        this.formatPeriod();
        this.formatedIds = this.formatList(this.ids);
        this.formatedTeams = this.formatList(this.teams);
        this.formatedCustomers = this.formatList(this.customers);
        this.formatedOperators = this.formatList(this.operators);
        this.formatedTags = this.formatList(this.tags);
    }
    formatList(list) {
        return list.map(item => {
            return item.text;
        }).join(', ');
    }
    formatPeriod() {
        this.formatedPeriod = `${this.period.start} - ${this.period.end}`;
    }
    verifyOverflow() {
        this.isCustomersOverflowed = this.isOverflowed('customers');
        this.isIdsOverflowed = this.isOverflowed('ids');
        this.isOperatorsOverflowed = this.isOverflowed('operators');
        this.isTagsOverflowed = this.isOverflowed('tags');
        this.isTeamsOverflowed = this.isOverflowed('teams');
        this.$rootScope.$apply();
    }
    isOverflowed(elementId) {
        const element = document.getElementById(elementId);
        if (element === null) {
            return false;
        }
        return element.scrollWidth > element.offsetWidth;
    }
}
ExportTicketModalController.$inject = ['close', 'isTranscriptionExporting', 'period', 'teams', 'operators', 'tags', 'customers', 'ids', '$translate', '$rootScope'];
